<template>
    <TransitionRoot as="template" :show="open">
        <Dialog as="div" class="fixed z-20 inset-0 overflow-y-auto">
            <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0"
                    enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                    <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </TransitionChild>

                <!-- This element is to trick the browser into centering the modal contents. -->
                <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                <TransitionChild as="template" enter="ease-out duration-300"
                    enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
                    leave-from="opacity-100 translate-y-0 sm:scale-100"
                    leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                    <div
                        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                            <h1 class="font-semibold text-2xl leading-tight">{{ is_resend_invitation ? 'Send a New Invitation to Your Landlord' : 'Invite Your Landlord' }}</h1>
                            <h2 class="mt-4">Invite your landlord to set up Rent Payments through RentRisk. Secure, seamless payments benefit both you and your landlord.</h2>
                            <p v-if="is_resend_invitation" class="text-gray-600 text-sm italic mt-1">
                                Note: Sending a new invitation will delete previous invitations.
                            </p>
                            <div class="mt-4">
                                <jet-label for="email" value="Landlord's Email"
                                    class="mb-2 block text-sm font-medium text-gray-700" />
                                <jet-input id="email" type="email" class="block w-full" v-model="form.email" required
                                    autofocus />
                            </div>
                            <p v-text="form.errors.email" class="text-red-500 text-sm"></p>
                        </div>
                        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 flex justify-end gap-2">
                            <button type="button" @click="$emit('close')" :disabled="!isButtonActive"
                                class="whiteButton">
                                Close
                            </button>
                            <button type="button" @click="submit" :disabled="!isButtonActive" class="primaryButton">
                                Send Invitation
                            </button>
                        </div>
                    </div>
                </TransitionChild>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script setup>
import { Dialog, DialogTitle, TransitionChild, TransitionRoot, DialogOverlay } from '@headlessui/vue'
import { useForm } from "@inertiajs/vue3";
import JetLabel from "@/Jetstream/Label.vue";
import JetInput from "@/Jetstream/Input.vue";
import { ref } from "vue";

const props = defineProps({
    open: Boolean,
    is_resend_invitation: Boolean
});

const emit = defineEmits(['close']);

const form = useForm({
    email: null,
});

const isButtonActive = ref(true);

function submit() {
    isButtonActive.value = false;

    form.post(route('rent-payments.landlord-invitation'), {
        onSuccess: () => {
            emit('close');
        },
        onFinish: () => {
            isButtonActive.value = true;
        },
    });
}
</script>